import useSWR from "swr";
import Layout from "../../../components/custom/Layout";
import useUnit from "../../../customHooks/useUnit";
import VirtualTable from "../../../components/custom/VirtualTable";
import { IQueue, IRFS } from "../../../globals/interfaces";
import { customFetcher } from "../../../utils";
import useMonthYear from "../../../components/MonthYearPicker/useMonthYear";
import MonthYearPicker from "../../../components/MonthYearPicker";
import ModalDetails from "./ModalDetails";
import useModal from "../../../customHooks/useModal";
import useItem from "../../../customHooks/useItem";

export type RFSData = IRFS & IQueue;

export default function RfsRecords() {

    const unit = useUnit();

    const {
        month,
        setMonth,
        year,
        setYear
    } = useMonthYear();

    const {
        data
    } = useSWR(`/rfs?unit=${unit}&month=${month}&year=${year}`, customFetcher<RFSData>);

    const useData = (data || []).map(item => {
        const useItem = {};
        for (const key in item) {
            if (typeof item[key] === 'string') {
                useItem[key] = item[key].toUpperCase();
            }
        }
        return useItem; 
    });

    const { item, id, setId } = useItem(data);
    const { modal, setModal } = useModal();

    const viewDetails = (id: number) => {
        setId(id);
        setModal(true);
    }

    return (
        <Layout>
            <h1>RFS Records</h1>
            <MonthYearPicker
                setMonth={setMonth}
                setYear={setYear}
            />
            <VirtualTable<IRFS>
                data={useData}
                mapping={[{
                    name: 'Truck ID',
                    value: 'truckNumber'
                }, {
                    name: 'Type',
                    value: 'cargoHandlingType'
                }, {
                    name: 'Company',
                    value: 'truckerName'
                }, {
                    name: 'Driver',
                    value: 'driverName'
                }, {
                    name: 'Started',
                    value: 'createdAt',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Log',
                    value: 'unitedApiRes',
                    dev: true
                }]}
                numRows={10}
                handleClick={item => viewDetails(item.id)}
            />
            <ModalDetails
                modal={modal}
                setModal={setModal}
                item={item}
            />
        </Layout>
    );
}

